<mat-accordion>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 0" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">1</span>
          <span class="title">Add Subcontractor</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11353.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label"> Name *</span>
        <span class="value">
          {{addSubcontractor?.name}}
        </span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11355.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label"> Email </span>
        <span class="value">
          {{addSubcontractor?.email}}
        </span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11356.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label"> Phone Number </span>
        <span class="value">
          {{addSubcontractor?.phone}}
        </span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Icon material-filter-center-focus.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Alternate Phone Number </span>
        <span class="value">
          {{addSubcontractor?.alternate_phone}}
        </span>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 1" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">2</span>
          <span class="title">Subcontractor Detail</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Icon material-account-balance-wallet.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Tax Number </span>
        <span class="value">{{subcontractorDetail?.tax_number}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Icon metro-cross.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Fax Number</span>
        <span class="value">{{subcontractorDetail?.fax}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 11941.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Website URL</span>
        <span class="value">{{subcontractorDetail?.website ? 'https://' + subcontractorDetail?.website : ''}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/home_icon_gray.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 1 </span>
        <span class="value">{{subcontractorDetail?.address?.address_line_1}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Path 17353.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 2 </span>
        <span class="value">{{subcontractorDetail?.address?.address_line_2}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5967.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">City </span>
        <span class="value">{{subcontractorDetail?.address?.city}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5971.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">State </span>
        <span class="value">{{subcontractorDetail?.address?.state_id?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5973.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Zip Code </span>
        <span class="value">{{subcontractorDetail?.address?.zipcode}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/home_icon_gray.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 1 </span>
        <span class="value">{{subcontractorDetail?.billing_address?.address_line_1}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Path 17353.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 2 </span>
        <span class="value">{{subcontractorDetail?.billing_address?.address_line_2}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5967.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">City </span>
        <span class="value">{{subcontractorDetail?.billing_address?.city}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5971.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">State </span>
        <span class="value">{{subcontractorDetail?.billing_address?.state_id?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5973.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Zip Code </span>
        <span class="value">{{subcontractorDetail?.billing_address?.zipcode}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/home_icon_gray.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 1</span>
        <span class="value">{{subcontractorDetail?.billing_address?.address_line_1}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Path 17353.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Address Line 2</span>
        <span class="value">{{subcontractorDetail?.shipping_address?.address_line_2}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5967.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">City</span>
        <span class="value">{{subcontractorDetail?.shipping_address?.city}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5971.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">State</span>
        <span class="value">{{subcontractorDetail?.shipping_address?.state_id?.name}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5973.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Zip Code</span>
        <span class="value">{{subcontractorDetail?.shipping_address?.zipcode}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5973.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Misc Notes</span>
        <span class="value">{{subcontractorDetail?.misc_notes}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Group 5973.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Notes</span>
        <span class="value">{{subcontractorDetail?.specific_notes}}</span>
      </div>
    </div>


  </mat-expansion-panel>

  <!-- <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 2" hideToggle *ngIf="!model">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="title_wrap">
        <span class="number">3</span>
        <span class="title">Subcontractor Contact</span>
      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Icon material-account-balance-wallet.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">First Name *</span>
      <span class="value">{{subcontractorContact?.first_name}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Icon metro-cross.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Last Name</span>
      <span class="value">{{subcontractorContact?.last_name}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Icon metro-cross.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Email *</span>
      <span class="value">{{subcontractorContact?.email}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Icon ionic-md-document.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Phone Number *</span>
      <span class="value">{{subcontractorContact?.phone}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Group 11941.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Cell Phone Number</span>
      <span class="value">{{subcontractorContact?.mobile}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Group 11941.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Contact Job Title</span>
      <span class="value">{{subcontractorContact?.job_title}}</span>
    </div>
  </div>
  <div class="wrapper">
    <img src="../../../../assets/img/general_icons/Group 5977.png" alt="icon" class="icon">
    <div class="wrap">
      <span class="label">Notes</span>
      <span class="value">{{subcontractorContact?.notes}}</span>
    </div>
  </div>
</mat-expansion-panel> -->

<mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 2  + expensionCount" hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="title_wrap">
        <span class="number">3</span>
        <span class="title">Subcontractor Certificates</span>
      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>
  @for (certificate of subcontractorCertificates?.certificates; track certificate) {
    <div>
      @if (certificate?.is_certified) {
        <div class="wrapper">
          <img src="../../../../assets/img/general_icons/Icon material-account-balance-wallet.png" alt="icon" class="icon">
          <div class="wrap">
            <span class="label">{{certificate?.name}}</span>
            <span class="value">{{certificate?.expiration_date | date}}</span>
          </div>
        </div>
      }
    </div>
  }
</mat-expansion-panel>

<mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 3 + expensionCount" hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="title_wrap">
        <span class="number">4</span>
        <span class="title">Add Covered Areas</span>
      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>
  @for (state of addCoveredAreas?.covered_areas; track state) {
    <div class="wrapper">
      <img src="../../../../assets/img/general_icons/Icon material-account-balance-wallet.png" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">{{state?.state_name}}</span>
        <span class="value">
          <mat-chip-listbox>
            @for (area of state?.covered_areas; track area) {
              <mat-chip-option>{{area}}</mat-chip-option>
            }
          </mat-chip-listbox>
        </span>
      </div>
    </div>
  }

  <!--    <div class="wrapper">-->
  <!--      <img src="../../../../assets/img/general_icons/Icon material-account-balance-wallet.png" alt="icon" class="icon">-->
  <!--      <div class="wrap">-->
  <!--        <span class="label">Covered Areas</span>-->
  <!--        <span class="value">{{addCoveredAreas?.covered_areas}}</span>-->
<!--      </div>-->
<!--    </div>-->

</mat-expansion-panel>
</mat-accordion>
